import { ExternalLink } from 'lucide-react';
import { DriveKeepActions } from '@/components/drives/DriveKeepActions';
import type { KeptRef } from '@/components/keep/KeepActions';
import { folderPart, formatBytes, formatDriveDate, type DriveFileRowData } from '@/utils/drive-file-row';

export interface DriveFileRowProps {
  file: DriveFileRowData;
  driveId: number;
  productLabel: string;
  kept: KeptRef | null;
}

function openWebUrl(webUrl: string): void {
  window.open(webUrl, '_blank', 'noopener,noreferrer');
}

export function DriveFileRow({ file, driveId, productLabel, kept }: DriveFileRowProps) {
  const date = formatDriveDate(file.modifiedAt);
  const webUrl = file.webUrl;

  return (
    <li className="py-2">
      <div className="flex items-center gap-2">
        <span className="min-w-0 truncate font-medium">{file.name}</span>
        {date ? <span className="shrink-0 text-xs text-muted-foreground">{date}</span> : null}
        {file.sizeBytes !== null ? (
          <span className="shrink-0 text-xs text-muted-foreground">{formatBytes(file.sizeBytes)}</span>
        ) : null}
        {webUrl ? (
          <button
            type="button"
            onClick={() => openWebUrl(webUrl)}
            className="ml-auto rounded p-1 text-muted-foreground transition-colors hover:bg-muted/40 hover:text-foreground"
            aria-label={`Open in ${productLabel}`}
            title={`Open in ${productLabel}`}
          >
            <ExternalLink className="h-3.5 w-3.5" />
          </button>
        ) : null}
      </div>
      <p className="min-w-0 truncate text-xs text-muted-foreground">{folderPart(file.path)}</p>
      <div className="mt-1">
        <DriveKeepActions driveId={driveId} path={file.path} fileName={file.name} kept={kept} />
      </div>
    </li>
  );
}
